<template>
  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content m-t100">
        <div class="modal-header">
          <h3 class="modal-title">Delete Item</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <h3 :style="'font-size:16px'">
            This action will delete the records permanently.<br />
            Are you sure?
          </h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-dark" data-dismiss="modal">
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-cp"
            @click="deleteItem"
            data-dismiss="modal"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

/**
 * @memberof module:ManageJob
 * @namespace components.delete_modal
 */
export default {
  computed: {
    ...mapGetters({
      deleteItemData: "$_manage_jobs/deleteItemModal",
    }),
  },
  methods: {
    /**
     * @memberof module:ManageJob.components.delete_modal
     * @description method - dispatch request to delete Job or Job category
     */
    deleteItem() {
      if (this.deleteItemData.type === "category") {
        this.$store.dispatch(
          "$_manage_jobs/deleteCategory",
          this.deleteItemData.id
        );
      } else {
        this.$store.dispatch("$_manage_jobs/deleteJob", {
          categoryId: this.deleteItemData.categoryId,
          jobId: this.deleteItemData.jobId,
        });
      }
    },
  },
  beforeDestroy() {
    $("#deleteModal").modal("hide");
    $(".modal-backdrop").hide();
    $("body").removeClass("modal-open");
  },
};
</script>
